import StudentsNewGrads from './StudentsNewGrads'

export default StudentsNewGrads
